'use strict'

import DataTableEditorValidator from './DataTableEditorValidator'
import $ from 'jquery'
import Notifier from '../common/Notifier'
import 'moment'

const ADD_ITEM_SELECTOR = '.addItem'
const EDIT_ITEM_SELECTOR = '.editItem'
const REMOVE_ITEM_SELECTOR = '.removeItem'

const FORM_ACTION = {
  CREATE: 'create',
  EDIT: 'edit',
  REMOVE: 'remove'
}

const BUTTONS = {
  EDIT: [
    {
      label: 'Save',
      fn: function () {
        this.submit()
      },
      className: 'btn-primary pull-left'
    },
    {
      label: 'Close',
      fn: function () {
        this.close()
      }
    }
  ],
  DELETE: [
    {
      label: 'Delete',
      fn: function () {
        this.submit()
      },
      className: 'btn-primary pull-left'
    },
    {
      label: 'Close',
      fn: function () {
        this.close()
      }
    }
  ]
}

/**
 * Change the modal layout configuration.
 * @param selector - dataTable selector
 */
function updateModalLayout (editor) {
  // Make the modal large.
  editor.on('open', function (e, mode, action) {
    // Configure the modal to be large.
    $('.modal-dialog').addClass('modal-lg')

    // Decrease the width used for the labels
    $('.modal-body').find('.control-label').removeClass('col-lg-4')
    $('.modal-body').find('.control-label').addClass('col-lg-2')

    // Increase the width used for the fields.
    $('.controls').removeClass('col-lg-8')
    $('.controls').addClass('col-lg-10')
  })
}

/**
 * Handles editor open event.
 */
function attachOpenEventHandler (idSrc, editor, parseCompositeKey, disableFields) {
  editor.on('open', function (e, mode, action) {
    if (idSrc != null) {
      if (parseCompositeKey) {
        let idObj = parseCompositeKey(idSrc)
        Object.keys(idObj).forEach(function (key, index) {
          if (action === FORM_ACTION.CREATE) {
            editor.enable(key)
          } else {
            editor.disable(key)
          }
        })
      } else {
        if (action === FORM_ACTION.CREATE) {
          editor.enable(idSrc)
        } else {
          editor.disable(idSrc)
        }
      }
    }

    if (disableFields && action === FORM_ACTION.EDIT) {
      for (let i = 0; i < disableFields.length; i++) {
        editor.disable(disableFields[i])
      }
    }
  })
}

/**
 * OnClick of the ".addItem" button, open the editor for adding a record.
 */
function attachAddEventHandler (editor, displayTitle, defaultFieldValues, addBtnSelector) {
  let selector = addBtnSelector || ADD_ITEM_SELECTOR
  $(selector).on('click', function (e) {
    e.preventDefault()
    let title = 'Add'
    if (typeof displayTitle !== 'undefined') {
      title = title + ' ' + displayTitle
    }

    // Open the editor.
    editor.create({
      title: title,
      buttons: BUTTONS.EDIT
    })

    if (defaultFieldValues) {
      editor.set(defaultFieldValues)
    }
  })
}

/**
 * OnClick of the ".editItem" button, open the editor for editing a record.
 */
function attachEditEventHandler (editor, selector, displayTitle) {
  $(selector).on('click', EDIT_ITEM_SELECTOR, function (e) {
    e.preventDefault()
    let title = 'Edit'
    if (typeof displayTitle !== 'undefined') {
      title = title + ' ' + displayTitle
    }

    // Open the editor.
    editor.edit($(this).closest('tr'), {
      title: title,
      buttons: BUTTONS.EDIT
    })
  })
}

/**
 * OnClick of the ".removeItem" button, open the editor for removing a record.
 */
function attachRemoveEventHandler (editor, selector) {
  $(selector).on('click', REMOVE_ITEM_SELECTOR, function (e) {
    e.preventDefault()
    // Open the editor.
    editor.remove($(this).closest('tr'), {
      title: 'Delete',
      message: 'Are you sure you wish to delete this record?',
      buttons: BUTTONS.DELETE
    })
  })
}

function onSubmitSuccess (editor) {
  editor.on('onSubmitSuccess', function (e, json, data) {
    Notifier.success('Record saved successfully')
  })
}

function preSubmitEventHandler (editor, parseCompositeKey) {
  editor.on('preSubmit', function (e, data, action) {
    // if removing a row or edit/create passes validations, check to see if composite key needs to be parsed
    if (action === FORM_ACTION.REMOVE || DataTableEditorValidator.validateEditorForm(action, editor)) {
      if (parseCompositeKey && data.id) {
        // remove action id is array
        if (action === FORM_ACTION.REMOVE) {
          for (let i = 0; i < data.id.length; i++) {
            data.id[i] = parseCompositeKey(data.id[i])
          }
        } else {
          data.id = parseCompositeKey(data.id)
        }
      }
    } else {
      // Validation failed
      return false
    }
  })
}

/**
 * Configure and initialize the editor.
 *
 * @param idSrc - dataTable row identifier.
 * @param tableSelector - dataTable selector
 * @param editorFields - Fields to be show in the editor.
 * @param apiEndPoint - Target when form is saved.
 */
function initializeEditor (idSrc, tableSelector, editorFields, editorSaveEndPoint, editorRemoveEndPoint, wireUpForm, parseCompositeKey) {
  let editor =
    new $.fn.dataTable.Editor({
      ajax: {
        create: {
          url: editorSaveEndPoint,
          type: 'POST',
          data: function (data) {
            return JSON.stringify(data)
          }
        },
        edit: {
          url: editorSaveEndPoint,
          type: 'POST',
          data: function (data) {
            return JSON.stringify(data)
          }
        },
        remove: {
          url: editorRemoveEndPoint,
          type: 'POST',
          data: function (data) {
            return JSON.stringify(data)
          }
        }
      },
      legacyAjax: true,
      table: tableSelector,
      idSrc: idSrc,
      fields: editorFields
    })

  updateModalLayout(editor)

  preSubmitEventHandler(editor, parseCompositeKey)

  if (wireUpForm) {
    wireUpForm(editor)
  }

  // overriding the editor default error messaging
  editor._message = function (el, msg) {
    if (typeof msg === 'function') {
      msg = msg(this, $(tableSelector).DataTable.Api(this.s.table))
    }

    el = $(el)

    if (!msg && editor.s.displayed) {
      // Clear the message with visual effect since the form is visible
      el
        .stop()
        .fadeOut(function () {
          el.html('')
        })
    } else if (!msg) {
      // Clear the message without visual effect
      el
        .html('')
        .css('display', 'none')
    } else if (msg && editor.s.displayed) {
      Notifier.error(msg)
    } else if (msg) {
      // Show the message without visual effect
      el
        .html(msg)
        .css('display', 'block')
    }
  }

  return editor
}

export default class DataTableEditor {
  // constructor (options) {
  // }

  createEditor (options) {
    this.idSrc = options.idSrc
    this.tableSelector = options.tableSelector
    this.editorFields = options.editorFields
    this.displayTitle = options.displayTitle
    this.editorSaveEndPoint = options.editorSaveEndPoint
    this.editorRemoveEndPoint = options.editorRemoveEndPoint
    this.wireUpForm = options.wireUpForm
    this.parseCompositeKey = options.parseCompositeKey
    this.defaultFieldValues = options.defaultFieldValues
    this.addBtnSelector = options.addBtnSelector
    this.disableFields = options.disableFields

    this.editor = initializeEditor(this.idSrc, this.tableSelector, this.editorFields, this.editorSaveEndPoint, this.editorRemoveEndPoint, this.wireUpForm, this.parseCompositeKey)

    attachEditEventHandler.call(this, this.editor, this.tableSelector)
    attachAddEventHandler(this.editor, this.displayTitle, this.defaultFieldValues, this.addBtnSelector)
    attachRemoveEventHandler(this.editor, this.tableSelector, this.displayTitle)
    attachOpenEventHandler(this.idSrc, this.editor, this.parseCompositeKey, this.disableFields)

    onSubmitSuccess(this.editor)

    return this.editor
  }

}



// WEBPACK FOOTER //
// ./src/js/common/DataTableEditor.js